import React from 'react';
import {
  ApiRequestsContext,
  ApiRequestsTypes,
} from '../../../data-catalog-shared';
import { DescriptionEditorElement, useInlineDescriptionEditor } from '../InlineDescriptionEditor';


export interface ColumnInlineDescriptionEditorProps {
  readonly canEditDescription: boolean;
  readonly columnLuid: string | null;
  readonly columnTableLuid: string | null;
  readonly description: string;
  readonly afterDescriptionChange: () => void;
}

export function ColumnInlineDescriptionEditor(props: ColumnInlineDescriptionEditorProps): JSX.Element {
  const { element } = useColumnInlineDescriptionEditor(props);
  return element;
}

export function useColumnInlineDescriptionEditor(props: ColumnInlineDescriptionEditorProps): DescriptionEditorElement {
  const { canEditDescription, columnLuid, columnTableLuid, description, afterDescriptionChange } = props;
  const { setColumnDescription } = React.useContext(ApiRequestsContext);

  const onSave = React.useCallback(async (inputText: string) => {
    const args: ApiRequestsTypes.SetColumnDescriptionArgs = {
      columnLuid: columnLuid ?? '',
      tableLuid: columnTableLuid ?? '',
      description: inputText
    };

    return await setColumnDescription(args);
  },
  [columnLuid, columnTableLuid, setColumnDescription]
  );

  return useInlineDescriptionEditor({
    canEdit: !!columnLuid && !!columnTableLuid && canEditDescription,
    onSave,
    initialDescription: description,
    afterSave: afterDescriptionChange,
    viewOnly: true
  });
}
